import { getSelectedSlotId, waitForSlots } from "./odsSlotService";

const payloadTweaks = (isUpToToday, slotId) => {
  let payloadObj = {
    startDate: true,
    endDate: true,
    slotStartDate: true,
    slotEndDate: true,
  };
  if (isUpToToday) {
    if (slotId === "ALL") {
      payloadObj.startDate = true;
      payloadObj.endDate = true;
      payloadObj.slotStartDate = true;
      payloadObj.slotEndDate = true;
    } else {
      payloadObj.startDate = false;
      payloadObj.endDate = false;
      payloadObj.slotStartDate = false;
      payloadObj.slotEndDate = false;
    }
  } else {
    payloadObj.startDate = false;
    payloadObj.endDate = false;
    payloadObj.slotStartDate = false;
    payloadObj.slotEndDate = false;
  }

  return payloadObj;
};

export const getOrderPollingPayload = async (selectedDate = null) => {
  const slotId = getSelectedSlotId();
  const locId = localStorage.getItem("locId");
  const today = selectedDate
    ? new Date(selectedDate).toLocaleDateString("en-CA")
    : new Date().toLocaleDateString("en-CA");

  const retailType = localStorage.getItem("retailType");

  // Compare selected date against today (time-stripped) to decide
  const todayMidnight = new Date();
  todayMidnight.setHours(0, 0, 0, 0);
  const selectedMidnight = (() => {
    if (!selectedDate) return new Date(todayMidnight);
    if (typeof selectedDate === "string" && /^\d{4}-\d{2}-\d{2}$/.test(selectedDate)) {
      const [y, m, d] = selectedDate.split("-").map(Number);
      return new Date(y, m - 1, d); // local midnight, no UTC shift
    }
    const d = new Date(selectedDate);
    d.setHours(0, 0, 0, 0);
    return d;
  })();
  const isUpToToday = selectedMidnight <= todayMidnight;

  const allowedKeys = payloadTweaks(isUpToToday, slotId);

  const payloadConfig = {
    RESTAURANT: {
      locationId: locId,
      page: 0,
      pageSize: 99,
      orderTypes: [
        "SWIGGY_ORDER",
        "ZOMATO_ORDER",
        "RESTAURANT_ORDER",
        "ONDC_ORDER",
        "WHATSAPP_ORDER",
        "OWNLY_ORDER",
      ],
      subOrderTypes: ["DELIVERY", "TAKE_AWAY", "QR_STORE_DINE_IN", "WHATSAPP_DINE_IN"],
      fulfilmentStatus: ["CREATED", "ACCEPTED", "PREPARING", "PACKAGED", "IN_TRANSIT", "DELIVERED"],
      // startDate: today,
      // endDate: today,
      // ...(isUpToToday && { startDate: today, endDate: today }),
      // slotStartDate: today,
      // slotEndDate: today,
      // ...(allowedKeys?.startDate && { startDate: today }),
      // ...(allowedKeys?.endDate && { endDate: today }),
      ...(allowedKeys?.slotStartDate && { slotStartDate: today }),
      ...(allowedKeys?.slotEndDate && { slotEndDate: today }),
    },

    GROCERY: {
      locationId: locId,
      page: 0,
      pageSize: 99,
      orderTypes: ["B2C_ORDER", "WHATSAPP_ORDER"],
      fulfilmentStatus: ["CREATED", "PACKAGED", "IN_TRANSIT", "DELIVERED"],
      ...(allowedKeys?.slotStartDate && { slotStartDate: today }),
      ...(allowedKeys?.slotEndDate && { slotEndDate: today }),
    },
  };

  if (slotId && slotId !== "ALL") {
    payloadConfig[retailType].slotIds = [slotId];
  } else if (!isUpToToday) {
    const slotIds = await waitForSlots();
    if (slotIds && slotIds?.length > 0) {
      payloadConfig[retailType].slotIds = slotIds;
    }
  }

  return payloadConfig[retailType];
};
